export const NET_PRICE_TYPE = 'NET'
export const GROSS_PRICE_TYPE = 'GROSS'
